import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/stores/global';

export function useVideos() {
    const global = useGlobalStore()
    const { videoDetails, currentVideoDetail } = storeToRefs(global)

    function geoJsonPolygonToBounds(geojsonStr: string): [[number, number], [number, number]] | null {
        try {
            const geojson = JSON.parse(geojsonStr)
            if (geojson.type === "Polygon" && Array.isArray(geojson.coordinates)) {
                const coords = geojson.coordinates[0]
                let minLat = coords[0][1], maxLat = coords[0][1]
                let minLng = coords[0][0], maxLng = coords[0][0]
                coords.forEach(([lng, lat]: [number, number]) => {
                    if (lat < minLat) minLat = lat
                    if (lat > maxLat) maxLat = lat
                    if (lng < minLng) minLng = lng
                    if (lng > maxLng) maxLng = lng
                })
                return [
                    [minLat, minLng],
                    [maxLat, maxLng]
                ]
            }
        } catch (e) {
            return null
        }
        return null
    }

    return {
        videoDetails,
        currentVideoDetail,
        geoJsonPolygonToBounds
    }
}